"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSdax = extractSdax;
exports.readEntryAsText = readEntryAsText;
exports.findEntriesByExtension = findEntriesByExtension;
const fflate_1 = require("fflate");
const utf8Decoder = new TextDecoder('utf-8');
function extractSdax(data) {
    const unzipped = (0, fflate_1.unzipSync)(data);
    const entries = new Map();
    for (const path of Object.keys(unzipped)) {
        if (path.endsWith('/')) {
            continue;
        }
        entries.set(path, { path, contents: unzipped[path] });
    }
    return { entries };
}
function readEntryAsText(entry) {
    return utf8Decoder.decode(entry.contents);
}
function findEntriesByExtension(extracted, extension) {
    const ext = extension.toLowerCase();
    const out = [];
    for (const path of extracted.entries.keys()) {
        if (path.toLowerCase().endsWith(ext)) {
            out.push(path);
        }
    }
    return out;
}
//# sourceMappingURL=sdaxArchive.js.map